const stateFilter = (state) => state;

export { stateFilter };
